import type { TypedDocumentNode } from '@apollo/client';
import { gql } from '@apollo/client';
import { FormattedMessage } from 'react-intl';

import type { Rarity } from '@sorare/core/src/__generated__/globalTypes';
import { Button } from '@sorare/core/src/atoms/buttons/Button';
import { ScarcityIcon } from '@sorare/core/src/atoms/icons/ScarcityIcon';
import { glossary } from '@sorare/core/src/lib/glossary';

import type { BuyingPlayerDetailsButton_anyPlayer } from './__generated__/index.graphql.ts';

type Props = {
  anyPlayer: BuyingPlayerDetailsButton_anyPlayer;
  rarity: Rarity;
  inSeason: boolean;
  onMarketClick: (playerSlug: string) => void;
};

export const BuyingPlayerDetailsButton = ({
  anyPlayer,
  rarity,
  onMarketClick,
}: Props) => {
  const { slug } = anyPlayer;
  return (
    <Button
      fullWidth
      color="secondary"
      size="medium"
      role="link"
      startIcon={<ScarcityIcon rarity={rarity} />}
      onClick={() => onMarketClick(slug)}
    >
      <FormattedMessage {...glossary.listings} />
    </Button>
  );
};

BuyingPlayerDetailsButton.fragments = {
  anyPlayer: gql`
    fragment BuyingPlayerDetailsButton_anyPlayer on AnyPlayerInterface {
      slug
    }
  ` as TypedDocumentNode<BuyingPlayerDetailsButton_anyPlayer>,
};
